import { BetBuilderPreviewSummary } from '../types/BetBuilderPreview';

export const getSummaryAsSuperbet = (summary: BetBuilderPreviewSummary) => {
    return summary.legs.map((leg) => leg.name).join(';');
};
